module.exports = __webpack_public_path__ + "static/media/nf.186ca3ef.svg";